import React, { useState, useEffect } from 'react';
import { Card, Select, message, Spin } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';
import StudentBindingManagement from './StudentBindingManagement';
const { Option } = Select;
const ParentBindingManagement = () => {
  const { user } = useAuth();
  const [classes, setClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchClasses();
  }, []);
  const fetchClasses = async () => {
    try {
      setLoading(true);
      const response = await api.get('/classes', { params: { schoolId: user?.workbenchSchoolId } });
      if (response.data.success) {
        const classList = response.data.data || [];
        setClasses(classList);
        // 如果有班级，默认选择第一个
        if (classList.length > 0) {
          setSelectedClassId(classList[0].id);
        }
      }
    } catch (error) {
      console.error('获取班级列表失败:', error);
      message.error('获取班级列表失败');
    } finally {
      setLoading(false);
    }
  };
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }
  return (
    <div style={{ padding: '24px' }}>
      <Card style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ fontWeight: 'bold' }}>选择班级：</span>
          <Select
            style={{ width: 300 }}
            placeholder="请选择班级"
            value={selectedClassId}
            onChange={(value) => setSelectedClassId(value)}
          >
            {classes.map((cls) => (
              <Option key={cls.id} value={cls.id}>
                {cls.name} {cls.grade ? `(${cls.grade})` : ''}
              </Option>
            ))}
          </Select>
        </div>
      </Card>
      {selectedClassId ? (
        <StudentBindingManagement classId={selectedClassId} />
      ) : (
        <Card>
          <div style={{ textAlign: 'center', padding: '50px', color: '#999' }}>
            请先选择一个班级
          </div>
        </Card>
      )}
    </div>
  );
};
export default ParentBindingManagement;
